<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;">
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-spacer/>
                    <v-toolbar-title v-show="$vuetify.breakpoint.smAndUp">Contas Financeiras</v-toolbar-title>
                    <v-spacer/>
                    <v-text-field
                        dense
                        clearable
                        outlined
                        single-line
                        hide-details
                        v-model="search"
                        label="Pesquise.."
                        append-icon="mdi-magnify"
                    />
                    <v-spacer/>
                    <v-btn color="primary" fab small @click="openCadastro">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card elevation="2" class="ma-1">
                    <v-card-text>
                        <v-data-table
                            fixed-header
                            :headers="headers"
                            :items="dados"
                            :mobileBreakpoint="0"
                            :loading="loading"
                            :height="$vuetify.breakpoint.height - 180"
                            @click:row="editar"
                            :disable-pagination="true"
                            :hide-default-footer="true"
                            :search="search"
                        >
                            <template v-slot:item.ativo="{ item }">
                                <v-icon :color="item.ativo ? 'success' : 'grey'">
                                    {{ item.ativo ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                </v-icon>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon small @click.stop="excluir(item)">
                                    <v-icon small color="error">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <ContaForm
                    :visible="visible"
                    :formData="form"
                    @onCadastro="onCadastro"
                    @close="close"
                />
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import ContaForm from './ContaForm';

export default {
    name: 'FinanceiroContas',

    components: {
        BaseContainer,
        ContaForm,
    },

    data: () => ({
        search: '',
        visible: false,
        loading: false,
        dados: [],
        form: {},
        headers: [
            { text: 'ID', value: 'id', width: 70 },
            { text: 'Nome', value: 'nome' },
            { text: 'Descrição', value: 'descricao' },
            { text: 'Ativo', value: 'ativo', width: 80, align: 'center' },
            { text: '', value: 'actions', width: 60, sortable: false, align: 'end' },
        ],
    }),

    mounted() {
        this.consultar();
    },

    methods: {
        consultar() {
            this.loading = true;
            this.dados = [];

            this.$http.get('financeiro-interno/contas').then(resp => {
                this.dados = resp.data.data;
            })
            .catch(() => {
                alert('Não foi possível carregar as contas');
            }).finally(() => (this.loading = false));
        },

        close() {
            this.visible = false;
            this.form = {};
        },

        openCadastro() {
            this.form = { ativo: true };
            this.visible = true;
        },

        onCadastro() {
            this.close();
            this.consultar();
        },

        editar(row) {
            this.form = row;
            this.visible = true;
        },

        excluir(item) {
            if (!confirm(`Excluir a conta "${item.nome}"?`)) return;

            this.$http.delete(`financeiro-interno/contas/${item.id}`)
                .then(() => this.consultar())
                .catch(e => {
                    alert(e?.response?.data?.message || 'Não foi possível excluir');
                });
        },
    },
}
</script>
